<template>
  <Breadcrumbs
      title="Routes"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Routes', path: '/routes' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <routesList/>
    </div>
  </div>
</template>

<script>

import routesList from "@/pages/master_data/routes/routeList.vue";

export default {
  components: {
    routesList
  }
}
</script>